import script from "./SettingModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingModal.vue?vue&type=script&lang=ts&setup=true"

import "./SettingModal.vue?vue&type=style&index=0&id=590c67a6&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590c67a6"]])

export default __exports__